/**
 * description 
 * created by liu.linhai
 * created on 2017/10/24
 */
'use strict';
angular.module('recentMeetingModule', [])
    .controller('recentMeetingCtrl', ['$scope', 'trsHttpService', '$filter', '$q', 'storageListenerService', 'globleParamsSet', function($scope, trsHttpService, $filter, $q, storageListenerService, globleParamsSet) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                'CURRPAGE': 1, // 当前页
                'PAGESIZE': 20, // 展现数据数量
                'PAGECOUNT': 1 // 总页数
            };
            $scope.status = {
                copyCurrPage: 1,
                position: 0
            };
            $scope.data = {
                items: [],
                customConfig: {
                    maxDate: globleParamsSet.dateFormat(new Date(), '-'),
                }
            };
            $scope.params = {
                serviceid: 'recentmeeting',
                modelid: 'search',
                area: $scope.status.positionValue,
                page_no: $scope.page.CURRPAGE - 1,
                page_size: $scope.page.PAGESIZE,
                field: '000'
            };
            $scope.typeParams = {
                'serviceid': 'recentmeeting',
                'modelid': 'fields'
            };
        }

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            // requestTypeDate().then(function() {
            requestData(); // ioij
            // });
            getTenantInfo();
        }

        /**
         * [getTenantInfo description] 获取租户信息
         * @return {[type]} [description]
         */
        function getTenantInfo() {
            var params = {
                serviceid: 'mlf_tenant',
                methodname: 'findTenantById'
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                var area;
                if (angular.isString(data.MEMO) && data.MEMO.indexOf(';') > 0) {
                    area = data.MEMO.split(';');
                    $scope.status.tenantArea = { name: area[0], value: area[1] };
                } else {
                    $scope.status.tenantArea = { name: '新疆', value: 'zj' };
                }
            });
        }

        /**
         * [queryByDropdown description] 筛选条件触发后请求数据
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */
        $scope.queryByDropdown = function() {
            if ($scope.data.untildate) {
                $scope.params.search_date = $scope.data.fromdate + ';' + $scope.data.untildate;
            } else {
                $scope.params.search_date = '';
            }
            requestData();
        };

        /**
         * [pageChanged description]近期政策的分页，近期政策功能结束
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.params.page_no = $scope.page.CURRPAGE - 1; // re
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        $scope.selectPageNum = function() {
            $scope.params.page_no = $scope.page.CURRPAGE - 1;
            $scope.params.page_size = $scope.page.PAGESIZE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [jumpToPage description:跳转指定页面]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            } else if ($scope.status.copyCurrPage < 1) {
                $scope.status.copyCurrPage = 1;
            }
            $scope.params.page_no = $scope.status.copyCurrPage - 1;
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };


        /**
         * [requestData 请求数据]
         * @return {[type]} [description]
         */
        function requestData() { // ok
            if ($scope.status.position == 0) {
                $scope.params.area = 'china';
            } else {
                $scope.params.area = $scope.status.tenantArea.value;
            }
            // sj
            $scope.params.page_size = $scope.page.PAGESIZE;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'get').then(function(data) { // meetging
                $scope.data.items = data.PAGEDLIST.PAGEITEMS;
                $scope.indexName = data.CONTENT.INDEXNAME;
                $scope.page.ITEMCOUNT = data.PAGEDLIST.TOTALITEMCOUNT;
                storageListenerService.previewPageTurningStorage($scope.data.items, 'GUID', 'resourceDetail');
            });

        }

        /**
         * [getPosition 切换中国或者新疆]
         * @param  {[type]} value [description]
         */
        $scope.getPosition = function(value) {
            $scope.$broadcast('clearDateWithOutCallback', {});
            $scope.params.search_date = '';
            $scope.params.search_word = '';
            $scope.params.page_no = 0; // met
            // 防止重复点击请求数据
            // 当点击的时候，如果该值等于‘china'且status为0，则返回
            if (value == 'china' && $scope.status.position == 0) {
                return;
                // 当点击的时候，如果该值等于‘zj'且status为1，则返回
            } else if (value == 'zj' && $scope.status.position == 1) {
                return;
            } else {
                // 当value是'zhongguo'，position = 0
                if (value == 'china') {
                    $scope.status.position = 0;
                    // 反之 position = 1;
                } else {
                    $scope.status.position = 1;
                }
                $scope.page.CURRPAGE = 1;
                $scope.status.copyCurrPage = 1;
                requestData(); // getpositon
            }
        };

        /**
         * [articleSearch 文章搜索]
         * @return {[type]} [event 阻止默认事件，防止每次按键触发搜索，event.kyeCode == 13 按下Enter回车可以进行搜索 或者 空格键也可进行搜索
         * ]
         */
        $scope.articleSearch = function(event) {
            if ((angular.isDefined(event) && event.keyCode == 13) || angular.isUndefined(event)) {
                if ($scope.data.untildate) {
                    $scope.params.search_date = $scope.data.fromdate + ';' + $scope.data.untildate;
                } else {
                    $scope.params.search_date = '';
                }
                $scope.params.page_no = 0;
                requestData();
            }
        };

    }]);
